import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

export const DiscordShape = {
  webhook_url: Yup.string().label("Webhook URL").url().required(),
  channel: Yup.string().label("Channel").required(),
};

export interface DiscordInput {
  webhook_url: string;
  channel: string;
}

yupResolver<DiscordInput>(Yup.object().shape(DiscordShape));
